module.exports = __webpack_public_path__ + "img/firefox.1a89311c.png";